const isEmpty = obj => Object.values(obj).every(v => !v);
// const isEmpty = obj => Object.keys(obj).length === 0;

export default isEmpty;
